/* eslint-disable no-param-reassign */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react/no-danger */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { IoIosShareAlt } from 'react-icons/io';
import { FiArrowUpRight } from 'react-icons/fi';
import { Link, useLocation, useParams } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser';
import { renderToString } from 'react-dom/server';

import { Helmet } from 'react-helmet';
import { Container, BgImage, ArticleBody, Others, Discover } from './styles';

import clap from '~/assets/icons/clap-icon.svg';
import avatar from '~/assets/defaults/david.png';
import discover1 from '~/assets/defaults/discover1.png';
import discover2 from '~/assets/defaults/discover2.png';
import discover3 from '~/assets/defaults/discover3.png';
import discover4 from '~/assets/defaults/discover4.png';
import discover5 from '~/assets/defaults/discover5.png';
import discover6 from '~/assets/defaults/discover6.png';

import api from '~/services/api';
import ModalEnterEmail from '~/components/ModalEnterEmail';
import { useResize } from '~/hooks/Resize';
import ModalShareDesk from '~/components/ModalShareDesk';
import ModalSaveMoney from '~/components/ModalSaveMoney';

interface IParams {
  slug: string;
  reference: string;
  origin?: string;
}

interface IArticleFiles {
  id: string;
  file_url: string;
}

interface IArticle {
  id: string;
  title: string;
  meta: string;
  body: string;
  slug: string;
  likes: number;
  articleFiles: IArticleFiles[];
}

const BlogArticles: React.FC = () => {
  const params = useParams<IParams>();
  const { width } = useResize();
  const [article, setArticle] = useState({} as IArticle);
  const [othersArticles, setOthersArticles] = useState<IArticle[]>([]);
  const [reference, setReference] = useState('');
  const [show, setShow] = useState(false);
  const [showChoice, setShowChoice] = useState(false);
  const [slug, setSlug] = useState('');
  const location = useLocation();

  useEffect(() => {
    if (params.reference) {
      localStorage.setItem('@AutoAffiliate:reference', params.reference);
      setReference(params.reference);
    } else {
      const referenceData = localStorage.getItem('@AutoAffiliate:reference');
      if (referenceData) {
        setReference(referenceData);
      }
    }
  }, [params.reference]);

  useEffect(() => {
    api
      .get(`articles/${params.slug}`)
      .then((response) => {
        const elements = ReactHtmlParser(response.data.body);
        let i = 1;
        const h2Qtd = elements.filter(
          (element) => element.type === 'h2'
        ).length;
        const newElements = elements.map((element) => {
          if (element.type === 'figure') {
            const childrenIndex = element.props.children.findIndex(
              (elementChildren: any) => elementChildren.type === 'figcaption'
            );
            if (
              childrenIndex >= 0 &&
              element.props.children[childrenIndex].props.children[0] &&
              element.props.children[childrenIndex].props.children[0].type ===
                'a'
            ) {
              const linkElement =
                element.props.children[childrenIndex].props.children[0];
              delete element.props.children[childrenIndex];
              let { href } = linkElement.props;
              if (href.includes('/i/')) {
                if (reference) {
                  href += reference;
                } else {
                  href = href.replace('/i/', '');
                }
              }
              const newElement = React.createElement(
                'a',
                {
                  href,
                  title: linkElement.props.children[0],
                  target: '_blank',
                },
                element
              );
              return newElement;
            }
            return element;
          }

          if (element.type === 'h2') {
            if (i === 2) {
              const announcementElement = ReactHtmlParser(
                '<div class="mx-auto"><button id="button_1" type="button" class="mt-5 mb-4 text-start mx-auto bg-marketing1 border-0"><b class="fw-600">Discover</b> how this <span>PLATFORM</span> can build you <b>multiple streams of income...</b></button><p class="mb-5 mx-auto captions text-center">Discover why AutoAffiliate is the most revolutionary way to start an online business. Create your account today and gain access to a new world of possibilities.</p></div>'
              );

              const fragment = React.createElement(
                React.Fragment,
                null,
                announcementElement[0],
                announcementElement[1],
                element
              );

              i += 1;
              return fragment;
            }

            if (h2Qtd >= 4 && i === 4) {
              const announcementElement = ReactHtmlParser(
                '<div class="mx-auto"><button id="button_2" type="button" class="mt-5 mb-4 text-start mx-auto bg-marketing2 border-0"><span class="bg-testimony"><svg class="d-none d-sm-block" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 76 66" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M35.5475 9.58485C21.5247 17.7111 14.7153 26.0979 14.7153 40.1105C15.6386 39.85 16.4465 39.85 17.2544 39.85C24.5831 39.85 31.6811 44.3299 31.6811 52.4041C31.6811 60.7908 25.7373 66 17.2544 66C6.29005 66 0 58.0821 0 43.8611C0 24.0663 10.0987 9.8453 28.9689 0L35.5475 9.58485ZM75.9423 9.58485C61.9195 17.7111 55.1101 26.0979 55.1101 40.1105C56.0334 39.85 56.8413 39.85 57.6492 39.85C64.978 39.85 72.0759 44.3299 72.0759 52.4041C72.0759 60.7908 66.1321 66 57.6492 66C46.7426 66 40.4525 58.0821 40.4525 43.8611C40.4525 24.0663 50.5513 9.8453 69.4214 0L76 9.58485H75.9423Z" fill="#116BFF" fill-opacity="0.56"/></svg><svg class="d-sm-none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 76 66" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M35.5475 9.58485C21.5247 17.7111 14.7153 26.0979 14.7153 40.1105C15.6386 39.85 16.4465 39.85 17.2544 39.85C24.5831 39.85 31.6811 44.3299 31.6811 52.4041C31.6811 60.7908 25.7373 66 17.2544 66C6.29005 66 0 58.0821 0 43.8611C0 24.0663 10.0987 9.8453 28.9689 0L35.5475 9.58485ZM75.9423 9.58485C61.9195 17.7111 55.1101 26.0979 55.1101 40.1105C56.0334 39.85 56.8413 39.85 57.6492 39.85C64.978 39.85 72.0759 44.3299 72.0759 52.4041C72.0759 60.7908 66.1321 66 57.6492 66C46.7426 66 40.4525 58.0821 40.4525 43.8611C40.4525 24.0663 50.5513 9.8453 69.4214 0L76 9.58485H75.9423Z" fill="#000000" /></svg><span class="testimony-title">It has truly transformed my financial situation.”</span><span class="testimony d-block my-4">“I used to struggle to make ends meet, but now I have multiple streams of passive income that continue to grow each month.”</span><span class="d-flex justify-content-center align-items-center avatar"><span class="image"></span><span><span class="d-block name">Jordan Richards</span><span class="d-block member">Member since 2023</span></span></span></span></button><p class="mb-5 mx-auto captions text-center">Building an online business has never been easier. Join our community and start creating multiple income streams. We handle all the work for you, free of charge.</p></div>'
              );

              const fragment = React.createElement(
                React.Fragment,
                null,
                announcementElement[0],
                announcementElement[1],
                element
              );

              i += 1;
              return fragment;
            }
            // if (i === 3) {
            //   const announcementElement = ReactHtmlParser(
            //     '<button id="button_2" type="button" class="mt-5 mb-4 text-start mx-auto bg-marketing2 border-0"><span class="bg-testimony"><svg class="d-none d-sm-block" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 76 66" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M35.5475 9.58485C21.5247 17.7111 14.7153 26.0979 14.7153 40.1105C15.6386 39.85 16.4465 39.85 17.2544 39.85C24.5831 39.85 31.6811 44.3299 31.6811 52.4041C31.6811 60.7908 25.7373 66 17.2544 66C6.29005 66 0 58.0821 0 43.8611C0 24.0663 10.0987 9.8453 28.9689 0L35.5475 9.58485ZM75.9423 9.58485C61.9195 17.7111 55.1101 26.0979 55.1101 40.1105C56.0334 39.85 56.8413 39.85 57.6492 39.85C64.978 39.85 72.0759 44.3299 72.0759 52.4041C72.0759 60.7908 66.1321 66 57.6492 66C46.7426 66 40.4525 58.0821 40.4525 43.8611C40.4525 24.0663 50.5513 9.8453 69.4214 0L76 9.58485H75.9423Z" fill="#116BFF" fill-opacity="0.56"/></svg><svg class="d-sm-none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 76 66" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M35.5475 9.58485C21.5247 17.7111 14.7153 26.0979 14.7153 40.1105C15.6386 39.85 16.4465 39.85 17.2544 39.85C24.5831 39.85 31.6811 44.3299 31.6811 52.4041C31.6811 60.7908 25.7373 66 17.2544 66C6.29005 66 0 58.0821 0 43.8611C0 24.0663 10.0987 9.8453 28.9689 0L35.5475 9.58485ZM75.9423 9.58485C61.9195 17.7111 55.1101 26.0979 55.1101 40.1105C56.0334 39.85 56.8413 39.85 57.6492 39.85C64.978 39.85 72.0759 44.3299 72.0759 52.4041C72.0759 60.7908 66.1321 66 57.6492 66C46.7426 66 40.4525 58.0821 40.4525 43.8611C40.4525 24.0663 50.5513 9.8453 69.4214 0L76 9.58485H75.9423Z" fill="#000000" /></svg><span class="testimony-title">It has truly transformed my financial situation.”</span><span class="testimony d-block my-4">“I used to struggle to make ends meet, but now I have multiple streams of passive income that continue to grow each month.”</span><span class="d-flex justify-content-center align-items-center avatar"><span class="image"></span><span><span class="d-block name">Jordan Richards</span><span class="d-block member">Member since 2023</span></span></span></span></button><p class="mb-5 mx-auto captions text-center">Building an online business has never been easier. Join our community and start creating multiple income streams. We handle all the work for you, free of charge.</p>'
            //   );

            //   const fragment = React.createElement(
            //     React.Fragment,
            //     null,
            //     announcementElement[0],
            //     announcementElement[1],
            //     element
            //   );

            //   i += 1;
            //   return fragment;
            // }

            i += 1;
          }

          return element;
        });
        let body = '';
        for (const element of newElements) {
          body += renderToString(element);
        }
        setArticle({ ...response.data, body });
        if (reference) {
          const button1Marketing = document.getElementById('button_1');
          if (button1Marketing) {
            button1Marketing.addEventListener('click', () => {
              setShowChoice(true);
            });
          }

          const button2Marketing = document.getElementById('button_2');
          if (button2Marketing) {
            button2Marketing.addEventListener('click', () => {
              setShowChoice(true);
            });
          }
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [params.slug, reference]);

  useEffect(() => {
    api
      .get<IArticle[]>(`articles/others`)
      .then((response) => {
        const data = response.data.filter((other) => other.id !== article.id);
        setOthersArticles(data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, [article.id]);

  const origin = useMemo(() => {
    const data = location.pathname.slice(1).split('/');

    if (params.origin) {
      let originData = '';
      switch (params.origin) {
        case 'rf':
          originData = 'AI Bot Facebook';
          break;
        case 'uf':
          originData = 'User Facebook';
          break;
        case 'ue':
          originData = 'User Email';
          break;
        case 'ux':
          originData = 'User Twitter (X)';
          break;
        case 'uw':
          originData = 'User Whatsapp';
          break;
        case 'utt':
          originData = 'User Tiktok ';
          break;
        case 'ul':
          originData = 'User Linkedin';
          break;
        case 'ut':
          originData = 'User Traffic';
          break;
        case 'aat':
          originData = 'AutoAffiliate Traffic';
          break;

        default:
          originData = '';
          break;
      }

      if (data.length > 1) {
        localStorage.setItem(
          '@AutoAffiliate:origin',
          `${originData}, ${data[0]}, ${data[1]}`
        );
        return `${originData}, ${data[0]}, ${data[1]}`;
      }

      if (data.length > 0) {
        localStorage.setItem(
          '@AutoAffiliate:origin',
          `${originData}, ${data[0]}`
        );
        return `${originData}, ${data[0]}`;
      }

      localStorage.setItem(
        '@AutoAffiliate:origin',
        `${originData}, ${location.pathname.slice(1)}`
      );
      return `${originData}, ${location.pathname.slice(1)}`;
    }

    if (data.length > 1) {
      localStorage.setItem('@AutoAffiliate:origin', `${data[0]}, ${data[1]}`);
      return `${data[0]}, ${data[1]}`;
    }

    if (data.length > 0) {
      localStorage.setItem('@AutoAffiliate:origin', data[0]);
      return data[0];
    }

    localStorage.setItem('@AutoAffiliate:origin', location.pathname.slice(1));
    return location.pathname.slice(1);
  }, [location.pathname, params.origin]);

  const handleShareMobile = useCallback(
    async (slugArticle) => {
      try {
        await (navigator as any).share({
          url: `https://autoaffiliate.ai/blog/${slugArticle}/i/${reference}`,
        });
        console.log('Share successful');
      } catch (error) {
        console.error('Error sharing:', error);
      }
    },
    [reference]
  );

  const handleShareDesk = useCallback((slugOthersArticle) => {
    setShow(true);
    setSlug(slugOthersArticle);
  }, []);

  const handleClickLike = useCallback(async (articleId) => {
    const isLiked = localStorage.getItem(
      `@AutoAffiliate:likeArticle-${articleId}`
    );
    const like = isLiked ? -1 : 1;
    await api.patch(`articles/like/${articleId}`, {
      like,
    });

    if (isLiked) {
      localStorage.removeItem(`@AutoAffiliate:likeArticle-${articleId}`);
    } else {
      localStorage.setItem(`@AutoAffiliate:likeArticle-${articleId}`, 'true');
    }

    setArticle((state) => ({
      ...state,
      likes: state.likes + like,
    }));
  }, []);

  const handleClickLikeOthers = useCallback(
    async (articleIndex) => {
      const newArticles = othersArticles.slice();
      const isLiked = localStorage.getItem(
        `@AutoAffiliate:likeArticle-${newArticles[articleIndex].id}`
      );
      await api.patch(`articles/like/${newArticles[articleIndex].id}`, {
        like: isLiked ? -1 : 1,
      });

      newArticles[articleIndex].likes += isLiked ? -1 : 1;

      if (isLiked) {
        localStorage.removeItem(
          `@AutoAffiliate:likeArticle-${newArticles[articleIndex].id}`
        );
      } else {
        localStorage.setItem(
          `@AutoAffiliate:likeArticle-${newArticles[articleIndex].id}`,
          'true'
        );
      }

      setOthersArticles(newArticles);
    },
    [othersArticles]
  );

  return (
    <Container>
      {Object.keys(article).length > 0 && (
        <>
          <Helmet>
            <title>{article.title}</title>
            <meta name="title" content={article.title} />
            <meta name="description" content={article.meta} />

            <meta property="og:type" content="website" />
            <meta
              property="og:url"
              content={`https://autoaffiliate.ai/blog/${article.slug}`}
            />
            <meta property="og:title" content={article.title} />
            <meta property="og:description" content={article.meta} />
            <meta
              property="og:image"
              content={article.articleFiles[0].file_url}
            />

            <meta property="twitter:card" content="summary_large_image" />
            <meta
              property="twitter:url"
              content={`https://autoaffiliate.ai/blog/${article.slug}`}
            />
            <meta property="twitter:title" content={article.title} />
            <meta property="twitter:description" content={article.meta} />
            <meta
              property="twitter:image"
              content={article.articleFiles[0].file_url}
            />
          </Helmet>
          <div className="d-none d-md-block container-fluid">
            <div className="row">
              <div className="col">
                <BgImage bgImage={article.articleFiles[0].file_url} />
              </div>
            </div>
          </div>
          <ArticleBody className="container">
            <div className="row justify-content-center">
              <div className="col-md-11 col-lg-10">
                <div className="bg">
                  <div className="d-flex justify-content-between">
                    <span className="hashtag">#MarketingAutomation</span>
                    <div className="text-sm-right d-sm-flex align-items-center min">
                      <span className="d-none d-sm-flex">3 minute read</span>{' '}
                      <button
                        type="button"
                        className="bg-transparent border-0"
                        onClick={() => handleClickLike(article.id)}
                      >
                        <span className="num-clap">
                          <img src={clap} alt="Clap" className="mx-2" />
                          {article.likes}
                        </span>
                      </button>
                    </div>
                  </div>
                  <div className="min d-sm-none">
                    <span className="">3 minute read</span>{' '}
                  </div>
                  <h1 className="my-4 my-sm-5">{article.title}</h1>
                  <div className="d-flex justify-content-between align-items-center my-4">
                    <div className="d-flex align-items-center">
                      <img
                        className="bg-avatar me-3"
                        src={avatar}
                        alt="avatar"
                      />
                      <div className="by">
                        <span>By David Motta</span>
                        <br />
                        <span>May 18, 2023</span>
                      </div>
                    </div>
                    <button
                      type="button"
                      onClick={() => {
                        if (width > 991) {
                          handleShareDesk(params.slug);
                        } else {
                          handleShareMobile(params.slug);
                        }
                      }}
                      className="btn-share bg-transparent"
                    >
                      Share Now <IoIosShareAlt />
                    </button>
                  </div>
                  {console.log(article.body)}
                  <div
                    className="body mt-5"
                    dangerouslySetInnerHTML={{ __html: article.body }}
                  />
                  <div className="d-flex align-items-center justify-content-center">
                    <button
                      type="button"
                      className="bg-transparent border-0"
                      onClick={() => handleClickLike(article.id)}
                    >
                      <span className="num-clap me-3">
                        <img src={clap} alt="Clap" className="mx-2" />
                        {article.likes}
                      </span>
                    </button>
                    <button
                      type="button"
                      className="btn-share-it bg-transparent"
                      onClick={() => {
                        if (width > 991) {
                          handleShareDesk(params.slug);
                        } else {
                          handleShareMobile(params.slug);
                        }
                      }}
                    >
                      Share it <IoIosShareAlt color="#116BFF" size={30} />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </ArticleBody>
        </>
      )}
      <Others className="container">
        <div className="row">
          <div className="col-12">
            <h2 className="pt-5 pb-4 my-5">You may also like...</h2>
          </div>
          {othersArticles.map((others, index) => (
            <>
              {index < 3 && (
                <div className="col-md-6 col-lg-4 px-xl-4 mb-5 pb-lg-5">
                  <div>
                    <Link
                      to={`${process.env.PUBLIC_URL}/blog/${others.slug}/i/${reference}`}
                    >
                      <div className="position-relative bg-gradient-others">
                        <img
                          src={others.articleFiles[0].file_url}
                          alt="Image"
                          className="thumb w-100"
                        />
                      </div>
                      <h3 className="mt-5">{others.title}</h3>
                      <p className="mb-0 py-3">{others.meta}</p>
                    </Link>
                    <div className="d-flex align-items-center justify-content-between">
                      <div>
                        <Link
                          to={`${process.env.PUBLIC_URL}/blog/${others.slug}/i/${reference}`}
                        >
                          Read article <FiArrowUpRight color="#000" size={22} />
                        </Link>
                      </div>
                      <div>
                        <button
                          type="button"
                          className="bg-transparent border-0"
                          onClick={() => handleClickLikeOthers(index)}
                        >
                          <span className="num-clap me-3">
                            <img src={clap} alt="Clap" className="mx-2" />
                            {others.likes}
                          </span>
                        </button>
                        <button
                          type="button"
                          className="btn-share-it bg-transparent border-0"
                          onClick={() => {
                            if (width > 991) {
                              handleShareDesk(others.slug);
                            } else {
                              handleShareMobile(others.slug);
                            }
                          }}
                        >
                          Share it <IoIosShareAlt color="#116BFF" size={30} />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </>
          ))}
        </div>
      </Others>
      <Discover className="container">
        <div className="row justify-content-center">
          <div className="col-sm-11 col-xxl-10 my-5">
            <div className="bg-discover py-5 position-relative">
              <img
                src={discover1}
                alt="Person"
                className="pe-none discover1 position-absolute zoom"
              />
              <img
                src={discover2}
                alt="Person"
                className="d-none d-sm-block pe-none discover2 position-absolute zoom"
              />
              <img
                src={discover3}
                alt="Person"
                className="d-none d-sm-block pe-none discover3 position-absolute zoom"
              />
              <img
                src={discover4}
                alt="Person"
                className="pe-none discover4 position-absolute zoom"
              />
              <img
                src={discover5}
                alt="Person"
                className="pe-none discover5 position-absolute zoom"
              />
              <img
                src={discover6}
                alt="Person"
                className="pe-none discover6 position-absolute zoom"
              />

              <div className="row">
                <div className="col-10 col-sm-8 col-xl-7 mx-auto text-center px-0 px-sm-3 pt-5 py-sm-5">
                  <h3 className="mb-4 mb-sm-2">
                    JOIN AUTOAFFILIATE
                    <br className="d-md-none" /> NOW AND
                  </h3>

                  <h2 className="mb-4 mb-sm-3">
                    Discover the Effortless Way to Create{' '}
                  </h2>

                  <p className="px-4 px-sm-0">
                    Multiple Streams of Passive Income on autopilot!
                  </p>

                  <button
                    type="button"
                    onClick={() => setShowChoice(true)}
                    className="mt-3 btn-yes"
                  >
                    Show Me How
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Discover>

      <ModalSaveMoney
        className="mt-5"
        showChoice={showChoice}
        onClickShow={() => setShowChoice(false)}
      />

      <ModalShareDesk
        show={show}
        onHide={() => setShow(false)}
        reference={reference}
        slug={slug}
      />
    </Container>
  );
};

export default BlogArticles;
